import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {closeSummaryPopup} from "../../redux/actions";

export const SummaryPopup = () => {
    const dispatch = useDispatch()
    const summaryPopup = useSelector(state => state.app.summaryPopup)
    const lang = useSelector(state => state.app.currentLang)
    const summary = useSelector(state => state.table.summary)

    if (!summaryPopup) {
        return null;
    }
    return (
        <div className="userPopup">
            <div className="userPopup__back" onClick={() => dispatch(closeSummaryPopup())}></div>
            <div className="userPopup__wrap">
                <div className="userPopup__box">
                    <div className="userPopup__head">
                        {lang.table4}
                        <div className="userPopup__close" onClick={() => dispatch(closeSummaryPopup())}>
                        </div>
                    </div>
                    <div className="userPopup__body">
                        <div className="summaryPopup">
                            <div className="summaryPopup__heading">
                                {lang.table5}
                            </div>
                            <div className="summaryPopup__row">
                                <div><span>{lang.table6}</span></div>
                                <div><span>{summary.comments}</span></div>
                            </div>
                            <div className="summaryPopup__row">
                                <div><span>{lang.table7}</span></div>
                                <div><span>{summary.messages}</span></div>
                            </div>
                            <div className="summaryPopup__row">
                                <div><span>{lang.table8}</span></div>
                                <div><span>{summary.liveComments}</span></div>
                            </div>
                            <div className="summaryPopup__heading">
                                {lang.table9}
                            </div>
                            <div className="summaryPopup__row">
                                <div><span>{lang.table10}</span></div>
                                <div><span>{summary.points}</span></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}